import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { KONTAK } from "@/constants/testIds";
import { toast } from "sonner";
import { Send, MapPin, Phone, Mail, Globe } from "lucide-react";

const SUBJECTS = ["Pertanyaan Umum", "Data Perikanan", "Layanan Perizinan", "Pengaduan", "Kerjasama", "Lainnya"];

export default function Kontak() {
  const [form, setForm] = useState({ nama: "", email: "", instansi: "", subject: SUBJECTS[0], pesan: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/kontak", form);
      toast.success(data.message || "Pesan terkirim");
      setForm({ nama: "", email: "", instansi: "", subject: SUBJECTS[0], pesan: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="mb-12">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Kontak</div>
        <h1 className="font-heading font-bold text-3xl lg:text-5xl text-[#003A5C]">Hubungi Kami</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">Tim SILAING siap membantu pertanyaan seputar data, layanan, kerjasama, dan pengaduan.</p>
      </div>

      <div className="grid lg:grid-cols-[1.2fr_1fr] gap-8">
        <form onSubmit={submit} className="bg-[#003A5C] text-white rounded-3xl p-8 lg:p-10 shadow-2xl">
          <h2 className="font-heading font-bold text-2xl mb-6">Kirim Pesan</h2>          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#48CAE4] font-semibold mb-1.5">Nama Lengkap *</label>
              <input required data-testid={KONTAK.formNama} value={form.nama} onChange={set("nama")} className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-white placeholder-white/40 focus:bg-white/15 focus:border-[#48CAE4] outline-none" placeholder="John Doe" />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#48CAE4] font-semibold mb-1.5">Email *</label>
              <input required type="email" data-testid={KONTAK.formEmail} value={form.email} onChange={set("email")} className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-white placeholder-white/40 focus:bg-white/15 focus:border-[#48CAE4] outline-none" placeholder="anda@email.com" />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#48CAE4] font-semibold mb-1.5">Instansi</label>
              <input data-testid={KONTAK.formInstansi} value={form.instansi} onChange={set("instansi")} className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-white placeholder-white/40 focus:bg-white/15 focus:border-[#48CAE4] outline-none" placeholder="Nama instansi" />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#48CAE4] font-semibold mb-1.5">Subjek *</label>
              <select required data-testid={KONTAK.formSubject} value={form.subject} onChange={set("subject")} className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-white focus:bg-white/15 focus:border-[#48CAE4] outline-none">
                {SUBJECTS.map((s) => <option key={s} value={s} className="text-[#003A5C]">{s}</option>)}
              </select>
            </div>
          </div>
          <div className="mt-4">
            <label className="block text-xs uppercase tracking-widest text-[#48CAE4] font-semibold mb-1.5">Pesan *</label>
            <textarea required rows={6} data-testid={KONTAK.formPesan} value={form.pesan} onChange={set("pesan")} className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-white placeholder-white/40 focus:bg-white/15 focus:border-[#48CAE4] outline-none resize-none" placeholder="Tulis pesan Anda..." />
          </div>
          <button type="submit" disabled={busy} data-testid={KONTAK.formSubmit} className="mt-6 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#00B4D8] hover:bg-[#48CAE4] text-[#003A5C] font-bold disabled:opacity-60 transition-colors">
            <Send className="w-4 h-4" /> {busy ? "Mengirim..." : "Kirim Pesan"}
          </button>
        </form>

        <div className="space-y-4">
          <div className="rounded-2xl overflow-hidden shadow-md border border-slate-100 group">
            <img src="/assets/silaing/kantor-dkp.png" alt="Kantor Dinas Kelautan dan Perikanan Provinsi Jawa Barat" className="w-full aspect-[16/10] object-cover group-hover:scale-105 transition-transform duration-500" />
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-md border border-slate-100">
            <h3 className="font-heading font-bold text-[#003A5C] text-lg mb-4">Kantor DKP Jawa Barat</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#00B4D8] shrink-0" /><span>Jl. Wastukencana No.17, Babakan Ciamis, Sumur Bandung, Kota Bandung, Jawa Barat 40117</span></li>
              <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-[#00B4D8] shrink-0" /><span>(022) 4203471</span></li>
              <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#00B4D8] shrink-0" /><span>dkp@jabarprov.go.id</span></li>
              <li className="flex gap-3"><Globe className="w-4 h-4 mt-0.5 text-[#00B4D8] shrink-0" /><span>dkp.jabarprov.go.id</span></li>
            </ul>
          </div>
          <div className="bg-gradient-to-br from-[#005F8E] to-[#0086C6] text-white rounded-2xl p-6">
            <div className="text-xs uppercase tracking-widest text-[#48CAE4] font-semibold mb-2">Jam Layanan</div>
            <div className="font-heading font-bold text-xl mb-2">Senin — Jumat</div>
            <div className="text-white/90">08.00 — 16.00 WIB</div>
          </div>
        </div>
      </div>
    </div>
  );
}
